import { render, staticRenderFns } from "./ModelsOfProduct.vue?vue&type=template&id=e5beaa3a&scoped=true"
import script from "./ModelsOfProduct.vue?vue&type=script&lang=js"
export * from "./ModelsOfProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5beaa3a",
  null
  
)

export default component.exports